module.exports = function (e) {
  var t = {};

  function o(n) {
    if (t[n]) return t[n].exports;
    var r = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(r.exports, r, r.exports, o), r.l = !0, r.exports;
  }

  return o.m = e, o.c = t, o.d = function (e, t, n) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (e, t) {
    if (1 & t && (e = o(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) {
      o.d(n, r, function (t) {
        return e[t];
      }.bind(null, r));
    }
    return n;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 2);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("react-router-dom");
}, function (e, t, o) {
  var n = o(3),
      r = o(4),
      a = o(5),
      i = o(6),
      s = i.default;
  s.default = i.default, s.version = n.version, s.marketingbrands = a, s.elements = r, e.exports = s;
}, function (e) {
  e.exports = JSON.parse('{"name":"toccstyles","version":"2.0.0","author":"Alex Wyett","contributors":[],"scripts":{"newelement":"node src/newelement.js","createelements":"node src/createelements.js","rebuild":"node src/rebuild.js","buildcss":"node src/buildcss.js","watchcss":"node src/watchcss.js","upload":"node src/uploadToS3.js","stylelint":"stylelint \'**/*.scss\'; exit 0","test":"jest","build":"node_modules/.bin/webpack --mode production --progress --colors  --config webpack.config.js"},"jest":{"setupFilesAfterEnv":["./setup-tests.js"]},"vendorCopy":[{"from":"node_modules/@fortawesome/fontawesome-pro/webfonts","to":"src/scss/fonts/fontawesome"}],"dependencies":{"@fortawesome/fontawesome-pro":"^5.8.2","aws-sdk":"^2.462.0","dotenv":"^8.0.0","fs-extra":"^7.0.1","lz-string":"^1.4.4","node-sass":"^4.12.0","tabsutils":"git+ssh://git@bitbucket.org/carltonsoftware/tabsutils.git","vendor-copy":"^2.0.0","preact":"^10.5.12","react":"^16.8.3","react-dom":"^16.14.0","react-router":"^5.0.0","react-router-dom":"^5.0.0"},"style":"dist/1.0.2/vanilla/index.css","sass":"src/scss/vanilla.scss","main":"dist/index.js","repository":{"type":"git","url":"git+https://github.com/twbs/bootstrap.git"},"peerDependencies":{"react":"^16.8.3","preact":"^10.5.12","react-dom":"^16.14.0","react-router":"^5.0.0","react-router-dom":"^5.0.0"},"license":"MIT","devDependencies":{"@babel/core":"^7.12.17","@babel/preset-env":"^7.12.17","@babel/preset-react":"^7.12.13","babel-jest":"^25.0.0","babel-loader":"^8.2.2","clean-webpack-plugin":"^3.0.0","core-js":"^3.3.5","duplicate-package-checker-webpack-plugin":"^3.0.0","enzyme":"^3.11.0","enzyme-adapter-react-16":"^1.15.6","jest":"^25.0.0","stylelint":"^13.6.1","stylelint-config-standard":"^20.0.0","uglifyjs-webpack-plugin":"^2.2.0","webpack":"^4.29.6","webpack-cli":"^3.3.0","webpack-node-externals":"^2.5.2"}}');
}, function (e) {
  e.exports = JSON.parse('{"component":[{"name":"iconmedia","short":"Icon media","description":"A media element with an icon","createdby":"Tabs System User"},{"name":"content","short":"Content area","description":"A content area component","createdby":"Tabs System User"},{"name":"pricesummary","short":"Price summary","description":"A price summary table","createdby":"Tabs System User"},{"name":"propertyattribute","short":"Property attribute","description":"A property attribute and icon","createdby":"Tabs System User"},{"name":"pager","short":"Pager","description":"A pagination bar","createdby":"Tabs System User"},{"name":"reassurance","short":"Reassurance","description":"Reassurance component.  Similar to icon media.  A link with an icon and description.","createdby":"Tabs System User"},{"name":"breadcrumb","short":"Breadcrumb","description":"A breadcrumb navigation component.","createdby":"Tabs System User"},{"name":"customerreview","short":"Customer review","description":"A customer review element.  Includes title, body and date elements.","createdby":"Tabs System User"},{"name":"callout","short":"Callout","description":"A callout component","createdby":"Tabs System User"},{"name":"marketingmessage","short":"Marketing Message","description":"A marketing message component","createdby":"Tabs System User"},{"name":"notification","short":"Notifcation","description":"A notification bar component.","createdby":"Tabs System User"},{"name":"overlay","short":"Overlay","description":"An overlay element","createdby":"Tabs System User"},{"name":"thumbmenu","short":"Thumb menu","description":"Quick navigation menu for mobile use sitting at the bottom of the viewport.","createdby":"Tabs System User"},{"name":"button-group","short":"Button group","description":"Group buttons together on a single line.","createdby":"Tabs System User"},{"name":"buttonlabel","short":"Button Label","description":"A component consisting of a button and a label","createdby":"Tabs System User"},{"name":"imagetile","short":"Image Tile","description":"An image tile with text overlay","createdby":"Tabs System User"},{"name":"brandimagetile","short":"Brand Image Tile","description":"Another image tile component","createdby":"Tabs System User"},{"name":"media","short":"Media","description":"A media element","createdby":"Tabs System User"},{"name":"skeleton","short":"Skeleton loader","description":"Used to show a placeholder for loading content","createdby":"Tabs System User"},{"name":"calendar","short":"Calendar","description":"A calendar element","createdby":"Tabs System User"},{"name":"button-floating","short":"Floating Button","description":"Floating container for a button at the bottom of the screen","createdby":"Tabs System User"}],"element":[{"name":"detail","short":"Detail","description":"A detail element","createdby":"Tabs System User"},{"name":"slogan","short":"Slogan","description":"a site slogan","createdby":"Tabs System User"},{"name":"strapline","short":"Strapline","description":"A strapline element","createdby":"Tabs System User"},{"name":"comment","short":"Comment","description":"A comment element","createdby":"Tabs System User"},{"name":"socialmedialink","short":"Social Media Link","description":"A social media link showing an icon of the platform.","createdby":"Tabs System User"},{"name":"list","short":"List","description":"A list element","createdby":"Tabs System User"},{"name":"subtitle","short":"Sub Title","description":"A sub title element.","createdby":"Tabs System User"},{"name":"figure","short":"Figure","description":"A figure element with caption","createdby":"Tabs System User"},{"name":"button","short":"Button","description":"A button element","createdby":"Tabs System User"},{"name":"label","short":"Label","description":"A label element","createdby":"Tabs System User"},{"name":"booleansliderswitch","short":"Boolean Slider Switch","description":"On off slider button","createdby":"Tabs System User"},{"name":"spinner","short":"Spinner","description":"A spinner element","createdby":"Tabs System User"},{"name":"formelement","short":"Form Element","description":"A form element","createdby":"Tabs System User"}],"layout":[{"name":"tabletcolumn","short":"Tablet columns","description":"A special tablet only column layout","createdby":"Tabs System User"},{"name":"grid","short":"Grid","description":"A grid layout system for TOCC","createdby":"Tabs System User"},{"name":"bgwrap","short":"Background Wrapper","description":"A background wrapper which provides background colour to a component.","createdby":"Tabs System User"}]}');
}, function (e) {
  e.exports = JSON.parse('[{"id":1,"code":"ABMM","name":"Abersoch Holiday Homes","agency":"/v2/agency/3","defaultbookingbrand":"/v2/bookingbrand/1","website":"https://www.abersochholidayhomes.co.uk","email":"info@abersochholidayhomes.co.uk"},{"id":2,"code":"ALMM","name":"Aldeburgh Lettings","agency":"/v2/agency/27","defaultbookingbrand":"/v2/bookingbrand/23","website":"https://www.aldeburghlettings.co.uk","email":"info@aldeburghlettings.co.uk"},{"id":3,"code":"BBMM","name":"Best of Brighton Holiday Lettings","agency":"/v2/agency/4","defaultbookingbrand":"/v2/bookingbrand/2","website":"https://www.bestofbrighton.co.uk","email":"enquiries@bestofbrighton.co.uk"},{"id":4,"code":"BGMM","name":"Big House Holidays","agency":"/v2/agency/25","defaultbookingbrand":"/v2/bookingbrand/22","website":"https://www.bighouseholidays.co.uk","email":"info@bighouseholidays.co.uk"},{"id":5,"code":"BCMM","name":"Blueriver Cottages","agency":"/v2/agency/5","defaultbookingbrand":"/v2/bookingbrand/4","website":"https://www.bluerivercottages.co.uk","email":"info@bluerivercottages.co.uk"},{"id":6,"code":"COMM","name":"Cornish Horizons","agency":"/v2/agency/7","defaultbookingbrand":"/v2/bookingbrand/5","website":"https://www.cornishhorizons.co.uk","email":"cottages@cornishhorizons.co.uk"},{"id":7,"code":"CQMM","name":"Cornish Quay","agency":"/v2/agency/8","defaultbookingbrand":"/v2/bookingbrand/6","website":"https://www.cornquay.com","email":"enquiries@cornquay.com"},{"id":8,"code":"OCMM","name":"Original Cottages","agency":"/v2/agency/16","defaultbookingbrand":"/v2/bookingbrand/13","website":"https://www.originalcottages.co.uk/","email":"hello@originalcottages.co.uk"},{"id":9,"code":"CUMM","name":"Curlew Cottages","agency":"/v2/agency/10","defaultbookingbrand":"/v2/bookingbrand/8","website":"http://www.curlewcottages.co.uk","email":"enquiries@curlewcottages.co.uk"},{"id":10,"code":"DDMM","name":"Discovery Holiday Homes","agency":"/v2/agency/11","defaultbookingbrand":"/v2/bookingbrand/9","website":"https://www.discoveryholidayhomes.com","email":"hello@discoveryholidayhomes.com"},{"id":11,"code":"FLMM","name":"Flagship Holiday Homes","agency":"/v2/agency/28","defaultbookingbrand":"/v2/bookingbrand/25","website":"https://www.flagshipholidayhomes.co.uk","email":"info@flagshipholidayhomes.co.uk"},{"id":12,"code":"FRMM","name":"Kent and Sussex Holiday Cottages","agency":"/v2/agency/13","defaultbookingbrand":"/v2/bookingbrand/11","website":"https://www.kentandsussexcottages.co.uk","email":"info@kentandsussexcottages.co.uk"},{"id":13,"code":"LPMM","name":"Looe and Polperro Holidays","agency":"/v2/agency/18","defaultbookingbrand":"/v2/bookingbrand/12","website":"https://www.looeandpolperroholidays.co.uk","email":"info@looeandpolperroholidays.co.uk"},{"id":14,"code":"CRMM","name":"Marsdens Cornish Cottages","agency":"/v2/agency/9","defaultbookingbrand":"/v2/bookingbrand/13","website":"http://www.cornish-cottages.co.uk","email":"cornwall@marsdens.co.uk"},{"id":15,"code":"MAMM","name":"Marsdens Devon Cottages","agency":"/v2/agency/19","defaultbookingbrand":"/v2/bookingbrand/14","website":"https://www.marsdens.co.uk","email":"devon@marsdens.co.uk"},{"id":16,"code":"MPMM","name":"Marsdens Property Management","agency":"/v2/agency/20","defaultbookingbrand":"/v2/bookingbrand/15","website":"www.northdevonlets.co.uk","email":"let@marsdens.co.uk"},{"id":17,"code":"JGMM","name":"Mrs Jane Good (Holidays) Ltd","agency":"/v2/agency/27","defaultbookingbrand":"/v2/bookingbrand/23","website":"www.mrsjanegoodltd.co.uk","email":"theoffice@mrsjanegoodltd.co.uk"},{"id":18,"code":"NOMM","name":"Norfolk Cottages","agency":"/v2/agency/22","defaultbookingbrand":"/v2/bookingbrand/16","website":"https://www.norfolkcottages.co.uk","email":"info@norfolkcottages.co.uk"},{"id":19,"code":"NDMM","name":"North Devon Holiday Cottages","agency":"/v2/agency/19","defaultbookingbrand":"/v2/bookingbrand/14","website":"https://www.northdevonholidays.co.uk","email":"info@northdevonholidays.co.uk"},{"id":20,"code":"PDMM","name":"Peak District Cottages","agency":"/v2/agency/24","defaultbookingbrand":"/v2/bookingbrand/18","website":"https://www.peakdistrictcottages.com","email":"info@peakdistrictcottages.com"},{"id":21,"code":"PCMM","name":"Powells Cottages","agency":"/v2/agency/23","defaultbookingbrand":"/v2/bookingbrand/19","website":"https://www.powells.co.uk","email":"info@powells.co.uk"},{"id":22,"code":"HCMM","name":"Red Rose","agency":"/v2/agency/15","defaultbookingbrand":"/v2/bookingbrand/20","website":"https://www.redroseholidaycottages.co.uk","email":"info@redroseholidaycottages.co.uk"},{"id":23,"code":"SLMM","name":"So Southwold","agency":"/v2/agency/26","defaultbookingbrand":"/v2/bookingbrand/21","website":"https://www.sosouthwold.co.uk","email":"reservations@sosouthwold.co.uk"},{"id":24,"code":"SFMM","name":"Suffolk Cottage Holidays","agency":"/v2/agency/25","defaultbookingbrand":"/v2/bookingbrand/22","website":"https://www.suffolkcottageholidays.com","email":"info@suffolkcottageholidays.com"},{"id":25,"code":"SSMM","name":"Suffolk Secrets","agency":"/v2/agency/27","defaultbookingbrand":"/v2/bookingbrand/23","website":"https://www.suffolk-secrets.co.uk","email":"holidays@suffolk-secrets.co.uk"},{"id":26,"code":"GLMM","name":"Good Life Lake District Cottages","agency":"/v2/agency/14","defaultbookingbrand":"/v2/bookingbrand/24","website":"https://www.goodlifelakedistrictcottages.co.uk","email":"stay@goodlifelakedistrictcottages.co.uk"},{"id":27,"code":"WAMM","name":"Wales Cottage Holidays","agency":"/v2/agency/28","defaultbookingbrand":"/v2/bookingbrand/25","website":"https://www.walescottageholidays.co.uk","email":"info@walescottageholidays.co.uk"},{"id":28,"code":"WYMM","name":"Wyke Dorset Cottages","agency":"/v2/agency/29","defaultbookingbrand":"/v2/bookingbrand/26","website":"https://www.dorsetcottages.com","email":"bookings@dorsetcottages.com"},{"id":29,"code":"INMM","name":"Yorkshire Holiday Cottages","agency":"/v2/agency/17","defaultbookingbrand":"/v2/bookingbrand/27","website":"https://www.yorkshireholidaycottages.co.uk","email":"info@yorkshireholidaycottages.co.uk"},{"id":30,"code":"SNMM","name":"SALT Norfolk","agency":"/v2/agency/22","defaultbookingbrand":"/v2/bookingbrand/28","website":"https://www.saltnorfolk.co.uk/","email":"info@saltnorfolk.co.uk"},{"id":31,"code":"BWMM","name":"Best of Wales","agency":"/v2/agency/2927138","defaultbookingbrand":"/v2/bookingbrand/29","website":"https://www.bestofwales.co.uk","email":""},{"id":32,"code":"ACMM","name":"Above Beach Cottages","agency":"/v2/agency/3135598","defaultbookingbrand":"/v2/bookingbrand/30","website":"https://www.abovebeachcottages.co.uk","email":""},{"id":34,"code":"PLMM","name":"Porthleven Holidays","agency":"/v2/agency/3135598","defaultbookingbrand":"/v2/bookingbrand/30","website":"https://www.porthlevenholidays.co.uk/","email":""},{"id":35,"code":"NRMM","name":"Niche Retreats","agency":"/v2/agency/3135599","defaultbookingbrand":"/v2/bookingbrand/31","website":"","email":""},{"id":36,"code":"IVMM","name":"St. Ives Holidays","agency":"/v2/agency/3313578","defaultbookingbrand":"/v2/bookingbrand/32","website":"https://www.stivesholidays.com","email":"mail@stivesholidays.com"},{"id":37,"code":"NBMM","name":"Northumbria Byways","agency":"/v2/agency/3387922","defaultbookingbrand":"/v2/bookingbrand/33","website":"https://www.northumbria-byways.com","email":"enquiries@northumbria-byways.com"},{"id":38,"code":"SXMM","name":"Stay Northumbria","agency":"/v2/agency/22627333","defaultbookingbrand":"/v2/bookingbrand/34","website":"https://www.staynorthumbria.co.uk","email":"stay@staynorthumbria.co.uk"},{"id":39,"code":"GDMM","name":"Grace Darling Holidays","agency":"/v2/agency/22779217","defaultbookingbrand":"/v2/bookingbrand/35","website":"https://www.gracedarlingholidays.com/","email":"info@gracedarlingholidays.com"},{"id":40,"code":"JBMM","name":"Jean Bartlett Cottage Holidays","agency":"/v2/agency/22802059","defaultbookingbrand":"/v2/bookingbrand/36","website":"https://www.jeanbartlettcottageholidays.co.uk/","email":"holidays@jeanbartlett.com"},{"id":41,"code":"HHMM","name":"Home from Home","agency":"/v2/agency/22869350","defaultbookingbrand":"/v2/bookingbrand/37","website":"https://www.homefromhome.com/","email":"enquiries@homefromhome.com"},{"id":42,"code":"CCMM","name":"Cornish Cottage Care","agency":"/v2/agency/22910929","defaultbookingbrand":"/v2/bookingbrand/38","website":"www.cornishcottagecare.co.uk","email":"info@cornishcottagecare.co.uk"},{"id":43,"code":"LCMM","name":"Lakes Cottage Care","agency":"/v2/agency/22910932","defaultbookingbrand":"/v2/bookingbrand/39","website":"www.originalcottages.co.uk","email":"hello@originalcottages.co.uk"}]');
}, function (e, t, o) {
  "use strict";

  o.r(t);
  var n = o(0),
      r = o.n(n);

  function a(e) {
    return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function i(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function s(e, t) {
    for (var o = 0; o < t.length; o++) {
      var n = t[o];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function c(e, t) {
    return (c = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function l(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var o,
          n = d(e);

      if (t) {
        var r = d(this).constructor;
        o = Reflect.construct(n, arguments, r);
      } else o = n.apply(this, arguments);

      return u(this, o);
    };
  }

  function u(e, t) {
    return !t || "object" !== a(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function d(e) {
    return (d = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  var p = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && c(e, t);
    }(u, e);
    var t,
        o,
        n,
        a = l(u);

    function u() {
      return i(this, u), a.apply(this, arguments);
    }

    return t = u, (o = [{
      key: "render",
      value: function value() {
        return 2 === this.props.level ? r.a.createElement("h2", {
          className: "oc-title"
        }, this.props.children) : 3 === this.props.level ? r.a.createElement("h3", {
          className: "oc-title"
        }, this.props.children) : 4 === this.props.level ? r.a.createElement("h4", {
          className: "oc-title"
        }, this.props.children) : 5 === this.props.level ? r.a.createElement("h5", {
          className: "oc-title"
        }, this.props.children) : 6 === this.props.level ? r.a.createElement("h6", {
          className: "oc-title"
        }, this.props.children) : r.a.createElement("h1", {
          className: "oc-title"
        }, this.props.children);
      }
    }]) && s(t.prototype, o), n && s(t, n), u;
  }(r.a.Component),
      f = o(1),
      b = function b(e) {
    return r.a.createElement("div", {
      className: "oc-content"
    }, e.children);
  },
      m = function m(e) {
    return r.a.createElement("i", {
      className: e.icon || "fa fa-question"
    });
  },
      y = function y(e) {
    var t = ["oc-button"];
    return e.loading && t.push("oc-loading"), e.disabled && t.push("oc-button--disabled"), e.expanded && t.push("oc-button--expanded"), e.inverse && t.push("oc-button--inverse"), e.hollow && t.push("oc-button--hollow"), e.success && t.push("oc-button--success"), e.alert && t.push("oc-button--alert"), e.tiny && t.push("oc-tiny"), e.small && t.push("oc-small"), e.large && t.push("oc-large"), e.search && t.push("oc-button--search"), r.a.createElement("button", {
      onClick: e.onClick,
      disabled: e.disabled,
      className: t.join(" ")
    }, e.children);
  };

  function h(e) {
    return (h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function g(e, t) {
    for (var o = 0; o < t.length; o++) {
      var n = t[o];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function w(e, t) {
    return (w = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function v(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var o,
          n = M(e);

      if (t) {
        var r = M(this).constructor;
        o = Reflect.construct(n, arguments, r);
      } else o = n.apply(this, arguments);

      return k(this, o);
    };
  }

  function k(e, t) {
    return !t || "object" !== h(t) && "function" != typeof t ? S(e) : t;
  }

  function S(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function M(e) {
    return (M = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  var O = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && w(e, t);
    }(i, e);
    var t,
        o,
        n,
        a = v(i);

    function i(e) {
      var t;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, i), (t = a.call(this, e)).state = {
        open: e.open || !1,
        promised: 0
      }, t.isOpen.bind(S(t)), t.isClosed.bind(S(t)), t.toggle.bind(S(t)), t;
    }

    return t = i, (o = [{
      key: "componentDidUpdate",
      value: function value(e) {
        this.props.open !== e.open && this.props.open !== this.state.open && this.toggle();
      }
    }, {
      key: "toggle",
      value: function value(e) {
        var t = this;
        e && e.preventDefault();
        var o,
            n = !this.state.open;
        this.state.promised >= this.props.runPromise ? this.setState({
          open: n
        }) : (o = n ? this.props.onOpen() : this.props.onClose()) instanceof Promise ? this.setState({
          loading: !0
        }, function () {
          o.then(function () {
            t.setState({
              loading: !1,
              open: n,
              promised: t.state.promised + 1
            });
          }).catch(function () {
            t.setState({
              loading: !1
            });
          });
        }) : this.setState({
          open: n
        });
      }
    }, {
      key: "isOpen",
      value: function value() {
        return !0 === this.state.open;
      }
    }, {
      key: "isClosed",
      value: function value() {
        return !1 === this.state.open;
      }
    }, {
      key: "render",
      value: function value() {
        var e = {
          className: this.props.className,
          style: this.props.style || {},
          loading: this.props.loading,
          disabled: this.props.disabled,
          onClick: this.toggle.bind(this)
        },
            t = r.a.createElement(r.a.Fragment, null, this.isClosed() && this.props.buttonText, this.isOpen() && this.props.closeButtonText);
        return r.a.createElement(r.a.Fragment, null, this.isOpen() && this.props.childrenBefore && this.props.children, r.a.createElement(y, e, t), this.isOpen() && this.props.childrenAfter && this.props.children);
      }
    }]) && g(t.prototype, o), n && g(t, n), i;
  }(r.a.Component);

  O.defaultProps = {
    anchor: !1,
    childrenBefore: !1,
    childrenAfter: !0,
    open: !1,
    buttonText: "Open",
    closeButtonText: "Close",
    onOpen: function onOpen() {},
    onClose: function onClose() {}
  };
  var C = O;

  function j(e) {
    return (j = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function T(e, t) {
    for (var o = 0; o < t.length; o++) {
      var n = t[o];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _(e, t) {
    return (_ = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function P(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var o,
          n = A(e);

      if (t) {
        var r = A(this).constructor;
        o = Reflect.construct(n, arguments, r);
      } else o = n.apply(this, arguments);

      return E(this, o);
    };
  }

  function E(e, t) {
    return !t || "object" !== j(t) && "function" != typeof t ? B(e) : t;
  }

  function B(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function A(e) {
    return (A = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  var N = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && _(e, t);
    }(i, e);
    var t,
        o,
        n,
        a = P(i);

    function i(e) {
      var t;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, i), (t = a.call(this, e)).state = {
        loading: e.loading || !1,
        disabled: e.disabled || !1
      }, t.top = r.a.createRef(), t.scrollTop = t.scrollTop.bind(B(t)), t;
    }

    return t = i, (o = [{
      key: "componentDidUpdate",
      value: function value(e) {
        this.scrollTop(), e.loading !== this.props.loading && this.setState({
          loading: this.props.loading
        }), e.disabled !== this.props.disabled && this.setState({
          disabled: this.props.disabled
        });
      }
    }, {
      key: "scrollTop",
      value: function value() {
        this.props.scrollOnUpdate && this.top && this.top.current.scrollIntoView();
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = function t() {
          var t;
          "function" == typeof e.props.onClose && ((t = e.props.onClose()) instanceof Promise && e.setState({
            loading: !0
          }, function () {
            t.then(function () {
              e.setState({
                loading: !1
              }, e.props.onAfterClose);
            }).catch(function () {
              e.setState({
                loading: !1
              }, e.props.onAfterClose);
            });
          }), e.props.onAfterClose()), "function" == typeof e.props.onBack && ((t = e.props.onBack()) instanceof Promise && e.setState({
            loading: !0
          }, function () {
            t.then(function () {
              e.setState({
                loading: !1
              }, e.props.onAfterBack);
            }).catch(function () {
              e.setState({
                loading: !1
              }, e.props.onAfterBack);
            });
          }), e.props.onAfterBack());
        };

        return r.a.createElement("div", {
          open: this.props.open ? "open" : "",
          className: "oc-overlay"
        }, r.a.createElement("div", {
          className: "oc-overlay__container" + (this.state.loading ? " oc-loading" : "")
        }, r.a.createElement("a", {
          onClick: t,
          className: "oc-overlay__close"
        }), !this.state.loading && this.props.title && r.a.createElement(p, {
          level: 3
        }, this.props.title), !this.state.loading && r.a.createElement(r.a.Fragment, null, this.props.children), "function" == typeof this.props.onClose && r.a.createElement("button", {
          onClick: t,
          style: {
            marginTop: "2rem",
            marginBottom: 0
          },
          className: "oc-button oc-button--expanded oc-button--hollow"
        }, "Close"), "function" == typeof this.props.onBack && r.a.createElement("button", {
          onClick: t,
          className: "tocc__customerarea__modal__back"
        }, " back")));
      }
    }]) && T(t.prototype, o), n && T(t, n), i;
  }(r.a.Component);

  N.defaultProps = {
    onClose: function onClose() {},
    onBack: !1,
    onAfterClose: function onAfterClose() {},
    onAfterBack: function onAfterBack() {},
    scrollOnUpdate: !0
  };
  var R = N;

  function x(e) {
    return (x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function U() {
    return (U = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var o = arguments[t];

        for (var n in o) {
          Object.prototype.hasOwnProperty.call(o, n) && (e[n] = o[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function H(e, t) {
    for (var o = 0; o < t.length; o++) {
      var n = t[o];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function L(e, t) {
    return (L = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function D(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var o,
          n = I(e);

      if (t) {
        var r = I(this).constructor;
        o = Reflect.construct(n, arguments, r);
      } else o = n.apply(this, arguments);

      return F(this, o);
    };
  }

  function F(e, t) {
    return !t || "object" !== x(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function I(e) {
    return (I = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  var q = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && L(e, t);
    }(i, e);
    var t,
        o,
        n,
        a = D(i);

    function i(e) {
      var t;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, i), (t = a.call(this, e)).state = {
        toggled: !1
      }, t;
    }

    return t = i, (o = [{
      key: "open",
      value: function value() {
        this.setState({
          toggled: !0
        });
      }
    }, {
      key: "close",
      value: function value() {
        this.setState({
          toggled: !1
        });
      }
    }, {
      key: "render",
      value: function value() {
        return r.a.createElement(C, U({
          onOpen: this.open.bind(this),
          onClose: this.close.bind(this),
          open: this.state.toggled
        }, this.props), this.state.toggled && r.a.createElement(R, {
          open: !0,
          title: this.props.title,
          onBack: this.props.onBack,
          onClose: this.props.onClose,
          onAfterClose: this.close.bind(this)
        }, this.props.children));
      }
    }]) && H(t.prototype, o), n && H(t, n), i;
  }(r.a.Component);

  function G(e) {
    return (G = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function W(e, t) {
    for (var o = 0; o < t.length; o++) {
      var n = t[o];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function J(e, t) {
    return (J = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function z(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var o,
          n = Q(e);

      if (t) {
        var r = Q(this).constructor;
        o = Reflect.construct(n, arguments, r);
      } else o = n.apply(this, arguments);

      return V(this, o);
    };
  }

  function V(e, t) {
    return !t || "object" !== G(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function Q(e) {
    return (Q = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  var Y = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && J(e, t);
    }(i, e);
    var t,
        o,
        n,
        a = z(i);

    function i(e) {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, i), a.call(this, e);
    }

    return t = i, (o = [{
      key: "render",
      value: function value() {
        var e = ["oc-formelement"];
        this.props.error && e.push("oc-formelement--error");
        var t = {
          id: this.props.id,
          onChange: this.props.onChange
        };
        return this.props.error && (t.className = "bd--alert"), this.props.defaultValue && (t.defaultValue = this.props.defaultValue), r.a.createElement("div", {
          className: e.join(" ")
        }, r.a.createElement("label", {
          htmlFor: this.props.id
        }, this.props.label), r.a.createElement("select", t, this.props.children));
      }
    }]) && W(t.prototype, o), n && W(t, n), i;
  }(r.a.Component);

  function K(e) {
    return (K = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function X(e, t) {
    for (var o = 0; o < t.length; o++) {
      var n = t[o];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function Z(e, t) {
    return (Z = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function $(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var o,
          n = oe(e);

      if (t) {
        var r = oe(this).constructor;
        o = Reflect.construct(n, arguments, r);
      } else o = n.apply(this, arguments);

      return ee(this, o);
    };
  }

  function ee(e, t) {
    return !t || "object" !== K(t) && "function" != typeof t ? te(e) : t;
  }

  function te(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function oe(e) {
    return (oe = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  var ne = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && Z(e, t);
    }(i, e);
    var t,
        o,
        n,
        a = $(i);

    function i(e) {
      var t;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, i), (t = a.call(this, e)).getOptions = t.getOptions.bind(te(t)), t;
    }

    return t = i, (o = [{
      key: "getOptions",
      value: function value() {
        var e = [];
        this.props.emptyOption && e.push(r.a.createElement("option", {
          key: "-1"
        }, this.props.emptyOption));

        for (var t = this.props.min, o = this.props.max, n = t; n <= o; n++) {
          e.push(r.a.createElement("option", {
            key: n,
            value: n
          }, n, " ", this.props.optionLabel, 1 !== n ? this.props.plural : ""));
        }

        return e;
      }
    }, {
      key: "render",
      value: function value() {
        return 0 === this.props.max ? null : r.a.createElement(Y, this.props, this.getOptions());
      }
    }]) && X(t.prototype, o), n && X(t, n), i;
  }(r.a.Component),
      re = {
    Callout: function Callout(e) {
      var t = {
        className: ["oc-callout"]
      };
      return e.collapse && t.className.push("oc-callout--collapse"), e.hollow && t.className.push("oc-callout--hollow"), e.inColourString && t.className.push("bg--".concat(e.inColourString, " c--white oc-content")), e.marginBottom && (t.styles = {
        marginBottom: e.marginBottom
      }), e.className && t.className.push(e.className), e.loading && t.className.push("oc-loading"), t.className = t.className.join(" "), r.a.createElement("div", t, e.header && r.a.createElement(p, {
        level: e.level || 3
      }, e.icon && r.a.createElement("i", {
        className: e.icon
      }), " ", e.header), e.children);
    },
    IconMedia: function IconMedia(e) {
      var t = r.a.createElement(r.a.Fragment, null, (e.title || e.header) && r.a.createElement(p, {
        level: e.level || 5
      }, r.a.createElement(m, {
        icon: e.icon
      }), e.title || e.header), r.a.createElement(b, null, e.children));
      return e.link || e.to ? r.a.createElement(f.Link, {
        to: e.link || e.to || "#",
        className: "oc-iconmedia"
      }, t) : r.a.createElement("a", {
        className: "oc-iconmedia"
      }, t);
    },
    Form: function Form(e) {
      var t = ["oc-form"];
      e.loading && t.push("oc-loading"), e.callout && t.push("oc-callout");
      var o = {};
      return e.creating && (o.minHeight = "740px", t.push("oc-loading")), r.a.createElement("form", {
        style: o,
        className: t.join(" "),
        autoComplete: "off"
      }, !e.creating && e.children);
    },
    StateButton: C,
    ToggleModalButton: q,
    Modal: R,
    Detail: function Detail(e) {
      var t = ["oc-detail"];
      return e.accordion && t.push("oc-detail--accordion"), r.a.createElement("details", {
        className: t.join(" ")
      }, r.a.createElement("summary", null, e.title || e.summary), e.children);
    },
    Header: p,
    Button: y,
    Icon: m,
    Content: b,
    Select: Y,
    NumberSelect: ne
  };

  t.default = re;
}]);